import React from 'react';
import PropTypes from 'prop-types';

import styles from './PricingGrid.scss';
import PricingOptionButton from './PricingOptionButton';
import Button from 'Components/Button';
import ConnectedFormattedMessage from 'Containers/ConnectedFormattedMessage';
import { ROUTES } from 'Settings/route-strings';

const PricingOption = props => {
  const { percentOff, id, type, selected } = props;
  const Icon = require(`./${id}.svg`);
  const price = percentOff ? props.price * percentOff : props.price;
  const priceString =
    id === 'custom' ? (
      <ConnectedFormattedMessage id="pricing_plan.custom.price_string" />
    ) : (
      `$${price}`
    );
  const trialButtonProps = { ...props };
  if (props.showBuyButtons)
    trialButtonProps.buttonType = 'primary-outline-yellow';
  return (
    <div
      className="PricingOption"
      data-type={id}
      data-inactive={typeof selected === 'string' && selected !== id}
      data-has-buy-button={props.showBuyButtons}
      data-static={props.hideButtons}
    >
      {percentOff ? (
        <div className="PricingOption__percent-off">
          <ConnectedFormattedMessage
            id="pricing_plan.percent_off"
            values={{ amount: percentOff * 100 }}
          />
        </div>
      ) : null}
      <Icon className="PricingOption__icon" />
      <h4 className="PricingOption__name">
        <ConnectedFormattedMessage id={`pricing_plan.${id}.title`} />
      </h4>
      <div className="PricingOption__price">
        {percentOff ? (
          <div className="PricingOption__original-price">
            <ConnectedFormattedMessage
              id="pricing_plan.price_string"
              values={{
                price: `$${props.price}`,
                term: (
                  <ConnectedFormattedMessage id="pricing_plan.annual_term" />
                ),
              }}
            />
          </div>
        ) : null}
        <div className="PricingOption__current-price">{priceString}</div>
        {props.term ? (
          <div className="PricingOption__term">
            <ConnectedFormattedMessage id="pricing_plan.annual_term" />
          </div>
        ) : null}
      </div>
      <div className="PricingOption__features">
        <ConnectedFormattedMessage
          id={`pricing_plan.${id}.features`}
          formattingCallback={text => {
            const lines = text.split('\n');
            return lines.map((line, i) => (
              <div
                className="PricingOption__feature"
                key={`option-${id}-feature-${i}`}
              >
                {line}
              </div>
            ));
          }}
        />
      </div>
      {!props.hideButtons ? (
        <PricingOptionButton {...trialButtonProps} />
      ) : null}
      {props.showBuyButtons && id !== 'custom' ? (
        <Button
          buttonType="primary"
          style={{ whiteSpace: 'nowrap' }}
          label={<ConnectedFormattedMessage id="pricing_plan.buy_now" />}
          route={{
            pathname: ROUTES.SUBSCRIPTION_USERNAME,
            state: { licenseType: id },
          }}
        />
      ) : null}
    </div>
  );
};

export default PricingOption;
